import React from 'react';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import './AboutUs.css';

const AboutUs = () => {
  return (
    <div className="wrapper">
      <Header />
      <main className="main-content about-us">
        <h2>Nuestra Misión</h2>
        <p>En Skylight Capital, nuestra misión es maximizar el valor para nuestros inversores a través de estrategias innovadoras y sostenibles en el sector inmobiliario. Nos comprometemos a identificar oportunidades de alta calidad que ofrezcan retornos sólidos y sostenibles a largo plazo.</p>
        <section className="team">
          <h3>Nuestro Equipo</h3>
          <div className="team-members">
            <div className="member">
              <img src="https://via.placeholder.com/150" alt="Sarah Thompson" />
              <h4>Sarah Thompson</h4>
              <p>CEO</p>
            </div>
            <div className="member">
              <img src="https://via.placeholder.com/150" alt="Michael Johnson" />
              <h4>Michael Johnson</h4>
              <p>CFO</p>
            </div>
            <div className="member">
              <img src="https://via.placeholder.com/150" alt="Emily Davis" />
              <h4>Emily Davis</h4>
              <p>COO</p>
            </div>
          </div>
        </section>
        <section className="approach">
          <h3>Nuestro Enfoque de Inversión</h3>
          <p>En Skylight Capital, adoptamos un enfoque de inversión riguroso y meticuloso. Nos enfocamos en la adquisición de activos inmobiliarios que presenten un alto potencial de apreciación y generación de ingresos. Utilizamos un proceso de debida diligencia exhaustivo para asegurar que cada inversión cumpla con nuestros altos estándares y objetivos estratégicos.</p>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default AboutUs;
